import { Text } from '@akin-home/text/native';
import { colors } from '@akin-home/theme';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import Checkbox from 'expo-checkbox';
import styled from 'styled-components/native';
import { LoginScreenPasswordMode } from '../login_screen_state';

type Props = {
  mode: LoginScreenPasswordMode;
  onPress?(mode: LoginScreenPasswordMode): void;
  icon: IconProp;
  label: string;
  selected?: boolean;
};

export function PasswordModeButton(props: Props) {
  const { selected } = props;

  function onPress() {
    props.onPress?.(props.mode);
  }

  return (
    <Container onPress={onPress} selected={selected}>
      <FontAwesomeIcon icon={props.icon} size={22} />
      <Text>{props.label}</Text>
      <Checkbox
        value={selected}
        color={selected ? colors.primary[70] : undefined}
      />
    </Container>
  );
}

const Container = styled.TouchableOpacity<{ selected?: boolean }>`
  border-width: 1px;
  border-radius: 20px;
  border-color: #c5c5c5;
  width: 120px;
  padding: 12px;

  align-items: center;

  gap: 10px;

  ${({ selected }) =>
    selected
      ? `
      border-color: ${colors.primary[70]}; 
      background-color: #F6F7F9;
      `
      : ''}
`;
